export default {
    methods: {
        currency(value, returnEmpty = false) {
            value = String(value).replace(",", ".");
            if (value) {
                return new Intl.NumberFormat("de-De", {
                    style: "currency",
                    currency: "EUR"
                }).format(value);
            } else {
                if (returnEmpty) {
                    return "";
                } else {
                    return new Intl.NumberFormat("de-De", {
                        style: "currency",
                        currency: "EUR"
                    }).format(0);
                }
            }
        },
        currencyColored(value, returnEmpty = false, reverse = false) {
            var color = "";
            if (reverse) {
                if (value > 0) {
                    color = "text-danger";
                } else if (value < 0) {
                    color = "text-success";
                }
            } else {
                if (value > 0) {
                    color = "text-success";
                } else if (value < 0) {
                    color = "text-danger";
                }
            }
            return `<span class="${color}">${this.currency(
                value,
                returnEmpty
            )}</span>`;
        }
    }
};
